import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/models';
import InformationQuote from '../InformationQuote';
import styles from './index.module.scss';

type ProductPricingProps = {
  id?: string;
  boxProduct: { productName: string; boxProductId: string };
  hasConsulted?: boolean;
  onConsultSuccess?: () => void;
};

const ConsultProductPricing: React.FC<ProductPricingProps> = ({
  id = 'productPricing',
  boxProduct,
  onConsultSuccess,
}) => {
  const { token } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const handleConsult = useCallback(() => {
    if (token) {
      dispatch({
        type: 'modal/open',
        payload: { content: <InformationQuote boxProduct={boxProduct} onSubmitSusccess={onConsultSuccess} /> },
      });
    } else {
      dispatch({ type: 'cbndatabox/setIsClickConsult', payload: true });
      dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
    }
  }, [boxProduct, dispatch, onConsultSuccess, token]);
  return (
    <section id={id} className={styles.section}>
      <h2 className={styles.title}>产品定价</h2>
      <p className={styles.instruction}>通过CBNDataBox获取报价</p>
      <button className={styles.consultBtn} onClick={handleConsult}>
        免费咨询
      </button>
    </section>
  );
};

export default ConsultProductPricing;
